import React from 'react';
import TabModel from 'models/utils/common/tab-model';
import { ReactComponent as FlaggedVerifiedIcon } from 'icons/flagged-and-verified.svg';
import { ReactComponent as FlaggedIcon } from 'icons/flagged.svg';
import { ReactComponent as VerifiedIcon } from 'icons/verified.svg';
import { ReactComponent as UnverifiedIcon } from 'icons/unverified.svg';
import { ReactComponent as ReviewedIcon } from 'icons/unverified.svg';
import { ReactComponent as FlaggedReviewedIcon } from 'icons/unverified.svg';
import { isNullOrUndefined } from 'utils/object-utils';
import { MenuOption } from 'models/utils/common/menu/menu-option-model';
import { ELEMENT_HIGHLIGHT_STATES } from 'constants/feature/tieout-element-constants';
import { RIGHT_PANELS } from 'constants/feature/panel-constants';
import { ROUTE_CONSTANTS } from 'constants/util/route-constants';
import DataGridColumn, {
  DataGridCheckboxColumn,
} from 'models/utils/common/data-grid/data-grid-column-model';
import MultilineEllipsis from '../../components/common/multi-line-ellipsis-text-component';
import { ReactComponent as SquareIcon } from 'icons/square.svg';
import { ReactComponent as TriangleIcon } from 'icons/triangle.svg';
import {
  BALANCE_SHEET_WORKPAPER,
  INCOME_STATEMENT_WORKPAPER,
  UNTAG_ELEMENT,
  OVERRIDE_SYSTEM_FLAG,
  UNLINK_REFERENCE,
  TRIANGLE_ICON_SIZE,
  SQUARE_ICON_SIZE,
} from './element-panel-constants';

const CONTENT_PANEL_ICON_SIZE = '12px';

export const STATEMENT_CONTENT_TABS = {
  STATEMENT: new TabModel({
    id: 1,
    intlTitle: 'global-header.statement',
  }),
  SPLIT: new TabModel({
    id: 2,
    intlTitle: 'global-header.split',
  }),
};

export const STATEMENT_ELEMENT_ID_PREFIX = 'CFTO_ELEMENT_';
export const STATEMENT_LEFT_ELEMENT_ID_PREFIX = 'CFTO_LEFT_ELEMENT_';
export const STATEMENT_SECTION_ID_PREFIX = 'CFTO_SECTION_';
export const STATEMENT_BOOKMARK_ID_PREFIX = 'CFTO_BOOKMARK_';
export const STATEMENT_LEFT_BOOKMARK_ID_PREFIX = 'LEFT_CFTO_BOOKMARK_';
export const STATEMENT_PSEUDO_ELEMENT_ID_PREFIX = 'CFTO_PSEUDO_ELEMENT_';
export const STATEMENT_DATE_ID = 'CFTO_DATE';
/** Since SectionContent components render always with a loader they have their own ID */
export const REACT_SECTION_ID_PREFIX = 'REACT_SECTION_';
export const OCR_SECTION_ID = 'statement-content-panel-page-';
export const OCR_LEFT_SECTION_ID = 'statement-content-panel-page-left-';
export const OCR_CONTAINER_BLOCK = 'statement-content-panel-ocr';
export const STATEMENT_CONTENT_PANEL_ZOOM_BLOCK =
  'statement-content-panel-zoom-id';
export const STATEMENT_CONTENT_PANEL_ZOOM_LEFT_BLOCK =
  'statement-content-panel-zoom-left-id';
export const SIDE_BY_SIDE_VIEW_RIGHT_BLOCK =
  'statement-content-page-id__center-panel'; //side-by-side right view legacy doc ID
export const SIDE_BY_SIDE_VIEW_LEFT_BLOCK =
  'statement-content-page-id__center-panel-left'; //side-by-side left view legacy doc ID
export const LEFT_VIEW_DOCUMENT_ID = `${OCR_CONTAINER_BLOCK}__document-id-left-view`; //side-by-side left view OCR doc ID
export const RIGHT_VIEW_DOCUMENT_ID = `${OCR_CONTAINER_BLOCK}__document-id`; //side-by-side right view OCR doc ID
export const SIDE_BY_SIDE_VIEW_OCR_COMBINATION_STATEMENT =
  'OCR_Combination_statements'; // represents both statements in side-by-side view as OCR statements
export const SIDE_BY_SIDE_VIEW_LEGACY_COMBINATION_STATEMENT =
  'Legacy_Combination_statements'; // represents both statements in side-by-side view as Legacy statements
export const SIDE_BY_SIDE_VIEW_LEFT_STATEMENT =
  'statement-content-panel-page-left-'; //side-by-side left view OCR sections doc ID
export const SIDE_BY_SIDE_VIEW_RIGHT_STATEMENT =
  'statement-content-panel-page-'; //side-by-side right view OCR sections doc ID
export const REPORT_PREVIEW_PAGE_HTML_CONTAINER_ID =
  'report-preview-page-left-panel-id__left-preview-html';
export const STATEMENT_CONTENT_BLOCK = 'statement-content-page';
export const STATEMENT_CONTENT_ID_BLOCK = 'statement-content-page-id';
export const CENTER_PANEL_ID = `${STATEMENT_CONTENT_ID_BLOCK}__center-panel`;
export const TABLE_CONTROLS_ID = `${STATEMENT_CONTENT_ID_BLOCK}__table-controls`;
export const SUMMARY_AI_BLOCK = 'summary-AI';
export const SUMMARY_AI_BLOCK_ID = 'summary-AI-block-id';
export const TIEOUT_SYNCSCROLL_SOURCEID = 'Tieout_SyncScroll_sourceId';
export const TIEOUT_SYNCSCROLL_TARGETID = 'Tieout_SyncScroll_targetId';
export const STATEMENT_CONTENT_PANEL = 'statement-content-panel';
export const STATEMENT_CONTENT_PANEL_OCR = 'statement-content-panel-ocr';
export const OMNIA_TB_UPDATE_ALERT = 'OMNIA_TB_UPDATE_ALERT';

// Auto Tieout and Side by Side compare modes and statuses
export const TRAIL_BALANCE_MODE = 'trail-balance-mode';
export const SIDE_BY_SIDE_COMPARE_MODE = 'side-by-side-mode';
export const AUTO_TIEOUT_COMPARE_MODE = 'auto-tieout-mode';
export const AUTO_TIEOUT_COMPARE_MODE_NEW = 'NEW';
export const AUTO_TIEOUT_COMPARE_MODE_INPROGRESS = 'IN_PROGRESS';
export const AUTO_TIEOUT_COMPARE_MODE_SUCCESS = 'COMPLETED';
export const AUTO_TIEOUT_COMPARE_MODE_FAILED = 'FAILED';
export const AUTO_TIEOUT_COMPARE_MODE_CANCELLED = 'CANCELLED';
export const AUTO_TIEOUT_UNLINK_SUCCESS = 'unlink successful';
export const SIDE_BY_SIDE_ORIGINAL = 'ORIGINAL';
export const SIDE_BY_SIDE_CARRYOVER = 'CARRY_OVER';

export const HEADER_PLUGIN_HEIGHT = 96;
export const SIDE_BY_SIDE_HEADER_HEIGHT = 48;
export const AUTO_TIEOUT_BANNER_HEIGHT = 41;
export const AUTO_TIEOUT_STALE_FLAG_BANNER_HEIGHT = 41;
export const SIDE_BY_SIDE_SUB_HEADER_HEIGHT = 48;
export const AUTO_TIEOUT_TAB_GROUP_HEADER_HEIGHT = 48;
export const SIDE_BY_SIDE_VIEW_FOOTER_HEIGHT = 75;

// Trial Balance Processing Statuses
export const TRIAL_BALANCE_PROCESSING_STATUS = {
  NEW: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  FAILED: 3,
  CANCELLED: 4,
};

export const STATEMENT_TYPES = {
  INCOME_STATEMENT: 'IncomeStatement',
  BALANCE_SHEET: 'BalanceSheet',
};

// Get key from TRIAL_BALANCE_PROCESSING_STATUS by value
export const getTrialBalanceProcessingStatusKey = (value) => {
  return Object.keys(TRIAL_BALANCE_PROCESSING_STATUS).find(
    (key) => TRIAL_BALANCE_PROCESSING_STATUS[key] === value,
  );
};

export const WORK_PAPER_TYPES_ID = {
  INTERNAL_TIEOUT: 0, //used for normal workpaper creation
  AUTO_TIEOUT: 1, //used from autot tieout to another document
  OMNIA_TRIAL_BALANCE: 2, //used for Balance sheet and income statement
  AUTO_TIEOUT_TB: 3, //used for trial balance workpaper in auto tieout
};

// Trial Balance Workpaper References
export const AUTO_TIEOUT_DROP_DOWN_OPTIONS = {
  [BALANCE_SHEET_WORKPAPER]: {
    referenceNumber: BALANCE_SHEET_WORKPAPER,
    type: BALANCE_SHEET_WORKPAPER,
    referenceName: 'Balance Sheet',
    icon: <SquareIcon width={SQUARE_ICON_SIZE} height={SQUARE_ICON_SIZE} />,
    visibleInTB: true,
    visibleInAutoTieout: false,
    shouldCallApi: true,
    includeReferenceInPayload: true,
    wpTypeByViewMode: {
      [TRAIL_BALANCE_MODE]: WORK_PAPER_TYPES_ID.OMNIA_TRIAL_BALANCE,
      [AUTO_TIEOUT_COMPARE_MODE]: WORK_PAPER_TYPES_ID.OMNIA_TRIAL_BALANCE,
    }
  },
  [INCOME_STATEMENT_WORKPAPER]: {
    referenceNumber: INCOME_STATEMENT_WORKPAPER,
    type: INCOME_STATEMENT_WORKPAPER,
    referenceName: 'Income Statement',
    icon: <TriangleIcon width={TRIANGLE_ICON_SIZE} height={TRIANGLE_ICON_SIZE} />,
    visibleInTB: true,
    visibleInAutoTieout: false,
    shouldCallApi: true,
    includeReferenceInPayload: true,
    wpTypeByViewMode: {
      [TRAIL_BALANCE_MODE]: WORK_PAPER_TYPES_ID.OMNIA_TRIAL_BALANCE,
      [AUTO_TIEOUT_COMPARE_MODE]: WORK_PAPER_TYPES_ID.OMNIA_TRIAL_BALANCE,
    }
  },
  [UNTAG_ELEMENT]: {
    referenceNumber: UNTAG_ELEMENT,
    type: UNTAG_ELEMENT,
    referenceName: 'Untag elements',
    visibleInTB: true,
    visibleInAutoTieout: false,
    isUntag: true,
    shouldCallApi: true,
    includeReferenceInPayload: false,
    wpTypeByViewMode: {
      [TRAIL_BALANCE_MODE]: WORK_PAPER_TYPES_ID.OMNIA_TRIAL_BALANCE,
      [AUTO_TIEOUT_COMPARE_MODE]: WORK_PAPER_TYPES_ID.OMNIA_TRIAL_BALANCE,
    },
  },
  [UNLINK_REFERENCE]: {
    type: UNLINK_REFERENCE,
    referenceName: 'Unlink Reference(s)',
    visibleInTB: true,
    visibleInAutoTieout: true,
    shouldCallApi: true,
    includeReferenceInPayload: true,
    useReferenceFromWorkpaper: true,
    wpTypeByViewMode: {
      [TRAIL_BALANCE_MODE]: WORK_PAPER_TYPES_ID.AUTO_TIEOUT_TB,
      [AUTO_TIEOUT_COMPARE_MODE]: WORK_PAPER_TYPES_ID.AUTO_TIEOUT,
    },
  },
  [OVERRIDE_SYSTEM_FLAG]: {
    type: OVERRIDE_SYSTEM_FLAG,
    referenceName: OVERRIDE_SYSTEM_FLAG,
    visibleInTB: true,
    visibleInAutoTieout: true,
    shouldCallApi: false,
    showConfirmModal: true,
    includeReferenceInPayload: false,
  },
};

export const getMenuOptions = (handleMapElements, viewMode) => {
  // Create menu options dynamically from the constants
  let keysToInclude = Object.keys(AUTO_TIEOUT_DROP_DOWN_OPTIONS);

  // Filter keys based on viewMode
  if (viewMode === AUTO_TIEOUT_COMPARE_MODE) {
    keysToInclude = Object.keys(AUTO_TIEOUT_DROP_DOWN_OPTIONS).filter(
      (key) => AUTO_TIEOUT_DROP_DOWN_OPTIONS[key].visibleInAutoTieout
    );
  } else if (viewMode === TRAIL_BALANCE_MODE) {
    keysToInclude = Object.keys(AUTO_TIEOUT_DROP_DOWN_OPTIONS).filter(
      (key) => AUTO_TIEOUT_DROP_DOWN_OPTIONS[key].visibleInTB
    );
  }

  const workpaperOptions = keysToInclude.map((key) => {
    const reference = AUTO_TIEOUT_DROP_DOWN_OPTIONS[key];
    return {
      id: key.toLowerCase().replace('_', '-'),
      label: reference.referenceName,
      onClick: () => handleMapElements(reference, viewMode),
      icon: reference.icon,
    };
  });

  return workpaperOptions;
};

// In Side by side page we have two statements side by side. Hence we should have different section id prefix
// for the two statements, so that id across the DOM is unique.
export const REACT_LEFT_STATEMENT_SECTION_ID_PREFIX = 'REACT_LEFT_SECTION_';

export const CONTENT_SEARCH_HIGHLIGHT_CLASS = 'content-search-highlight';

export const getStatusIcon = ({ elementData }) => {
  if (isNullOrUndefined(elementData)) {
    return null;
  } else if (elementData.isFlaggedAndReviewed()) {
    return (
      <FlaggedReviewedIcon
        width={CONTENT_PANEL_ICON_SIZE}
        height={CONTENT_PANEL_ICON_SIZE}
      />
    );
  } else if (elementData.isFlaggedAndVerified()) {
    return (
      <FlaggedVerifiedIcon
        width={CONTENT_PANEL_ICON_SIZE}
        height={CONTENT_PANEL_ICON_SIZE}
      />
    );
  } else if (elementData.isReviewed()) {
    return (
      <ReviewedIcon
        width={CONTENT_PANEL_ICON_SIZE}
        height={CONTENT_PANEL_ICON_SIZE}
      />
    );
  } else if (elementData.isUserFlagged()) {
    return (
      <FlaggedIcon
        width={CONTENT_PANEL_ICON_SIZE}
        height={CONTENT_PANEL_ICON_SIZE}
      />
    );
  } else if (elementData.isVerified()) {
    return (
      <VerifiedIcon
        width={CONTENT_PANEL_ICON_SIZE}
        height={CONTENT_PANEL_ICON_SIZE}
      />
    );
  } else {
    return (
      <UnverifiedIcon
        width={CONTENT_PANEL_ICON_SIZE}
        height={CONTENT_PANEL_ICON_SIZE}
      />
    );
  }
};

// Helper function to get the ancestor element
export const getAncestorElement = (element, levels, selector) => {
  if (!(element instanceof Element)) {
    console.error('Invalid element passed to getAncestorElement:', element);
    return null;
  }
  let ancestor = element;
  for (let i = 0; i < levels; i++) {
    if (ancestor && ancestor.parentNode) {
      ancestor = ancestor.parentNode;
      if (ancestor instanceof Element && ancestor.matches(selector)) {
        return ancestor;
      }
    } else {
      return null;
    }
  }
  return null;
};

export const EXPORT_PAGE_SIZE_ID = {
  LETTER: 1, // Letter (8.5 x 11)
  LEGAL: 2, // Legal (8.5 x 14)
  TABLOID: 3, // Tabloid (11 x 17)
  LEDGER: 4, // Ledger (17 x 11)
  A4: 5, // A4 (8.27 x 11.69)
  A3: 6, // A3 (11.69 x 16.54)
  A2: 7, // A2 (16.54 x 23.39)
};

export const EXPORT_PAGE_SIZE_OBJECT = {
  1: new MenuOption({
    id: 'page-size-option-letter',
    title: 'export-workpaper-pagesize-option-letter',
    value: EXPORT_PAGE_SIZE_ID.LETTER,
  }),
  2: new MenuOption({
    id: 'page-size-option-legal',
    title: 'export-workpaper-pagesize-option-legal',
    value: EXPORT_PAGE_SIZE_ID.LEGAL,
  }),
  3: new MenuOption({
    id: 'page-size-option-tabloid',
    title: 'export-workpaper-pagesize-option-tabloid',
    value: EXPORT_PAGE_SIZE_ID.TABLOID,
  }),
  4: new MenuOption({
    id: 'page-size-option-ledger',
    title: 'export-workpaper-pagesize-option-ledger',
    value: EXPORT_PAGE_SIZE_ID.LEDGER,
  }),
  5: new MenuOption({
    id: 'page-size-option-a4',
    title: 'export-workpaper-pagesize-option-a4',
    value: EXPORT_PAGE_SIZE_ID.A4,
  }),
  6: new MenuOption({
    id: 'page-size-option-a3',
    title: 'export-workpaper-pagesize-option-a3',
    value: EXPORT_PAGE_SIZE_ID.A3,
  }),
  7: new MenuOption({
    id: 'page-size-option-a2',
    title: 'export-workpaper-pagesize-option-a2',
    value: EXPORT_PAGE_SIZE_ID.A2,
  }),
};

export const EXPORT_PAGE_ORIENTATION_PORTRAIT = 'Portrait';

export const getElementHightlightState = (
  panel,
  elementDetailsId,
  elementId,
) => {
  // interntional double equal
  // eslint-disable-next-line eqeqeq
  if (panel === RIGHT_PANELS.ELEMENT && elementDetailsId == elementId) {
    return ELEMENT_HIGHLIGHT_STATES.OPENED;
  } else {
    return ELEMENT_HIGHLIGHT_STATES.DEFAULT;
  }
};

export const BLACKLINE_VIEW_STATUS = {
  BLK_REQ_RECEIVED: 'BLK_REQ_RECEIVED',
  GENERATING: 'GENERATING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export const getCurrencyValueAsMenuOptions = (currecyId, options) => {
  if (
    (typeof currecyId === 'string' || typeof currecyId === 'number') &&
    options.length
  ) {
    return options?.filter((item) => item.id === currecyId)[0];
  }
  return currecyId;
};

export const ELEMENT_QUICK_ACTIONS = {
  ADD_TICKMARK: 'elementAddTickmark',
  ADD_WORKPAPER: 'elementAddWorkpaper',
  CREATE_NEW_TICKMARK: 'elementCreateNewTickmark',
  ATTACH_EXISTING_TICKMARK: 'elementAttachExistingTickmark',
  USER_FLAG: 'elementUserFlag',
  REMOVE_USER_FLAG: 'elementRemoveUserFlag',
  OVERRIDE_FLAG: 'elementOverrideFlag',
  REMOVE_FORMULA: 'elementRemoveFormula',
  MANAGE_ATTRIBUTES: 'elementManageAttributes',
  VERIFY: 'elementVerify',
  UNVERIFY: 'elementUnverify',
  REVIEW: 'elementReview',
  UNREVIEW: 'elementUnreview',
  ASSIGN_COMFORT: 'elementAssignComfort',
  ASSIGN_COMFORT_LETTER: 'elementAssignComfortLetter',
  CHANGE_SIGN: 'elementChangeSign',
  LOADER: 'loader',
  ADDFORMULA: 'elementAddFormula',
  CREATE_NEW_WORKPAPER: 'CREATE_WORKPAPER',
  ATTACH_EXISTING_WORKPAPER: 'elementAttachExistingWorkpaper',
  ELLIPSIS_OPTION: 'ellipsisOption',
  TICKMARK_LIST_ITEM: 'tickmarkListItem',
  NO_TICKMARKS: 'noTickmarks',
  WORKPAPER_LIST_ITEM: 'workpaperListItem',
  NO_WORKPAPERS: 'noWorkpapers',
  UNLINK_AUTO_TIEOUT_REFERENCES: 'unlinkAutoTieoutReferences',
  CREATE_NEW_COMFORT_LETTER: 'CREATE_COMFORT_LETTER',
  ATTACH_EXISTING_COMFORT_LETTER: 'elementAttachExistingComfortLetter',
};

export const addWorkpaper = {
  id: 'add-workpaper',
  type: ELEMENT_QUICK_ACTIONS.ADD_WORKPAPER,
  label: 'quick-actions.label.add.workpaper',
  disabled: false,
  shouldCloseMenuOnClick: false,
  children: [
    {
      id: 'create-new-workpaper',
      type: ELEMENT_QUICK_ACTIONS.CREATE_NEW_WORKPAPER,
      label: 'quick-actions.label.add.annotation.new',
      disabled: false,
      shouldCloseMenuOnClick: true,
      shouldDispatch: false,
    },
    {
      id: 'attach-existing-workpaper',
      type: ELEMENT_QUICK_ACTIONS.ATTACH_EXISTING_WORKPAPER,
      label: 'quick-actions.label.add.annotation.existing',
      disabled: false,
      shouldCloseMenuOnClick: false,
      shouldDispatch: false,
    },
  ],
};

export const ELLIPSIS_OPTION = {
  id: 'ellipsis',
  type: ELEMENT_QUICK_ACTIONS.ELLIPSIS_OPTION,
  label: '...',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: false,
  isNotInternationalized: true,
  tooltipConfig: {
    id: 'quick-actions-tooltip-ellipsis-option',
    text: 'quick-actions.tooltip.ellipsis-option.view-all',
  },
};

export const NO_TICKMARK_OPTION = {
  id: `no-tickmarks`,
  type: ELEMENT_QUICK_ACTIONS.NO_TICKMARKS,
  label: 'quick-actions.attach-existing-tickmarks.no-tickmarks',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: false,
};

export const NO_WORKPAPER_OPTION = {
  id: `no-workpapers`,
  type: ELEMENT_QUICK_ACTIONS.NO_WORKPAPERS,
  label: 'quick-actions.attach-existing-workpapers.no-workpapers',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: false,
};

export const addTickmark = {
  id: 'add-tickmark',
  type: ELEMENT_QUICK_ACTIONS.ADD_TICKMARK,
  label: 'quick-actions.label.add.tickmark',
  disabled: false,
  shouldCloseMenuOnClick: false,
  children: [
    {
      id: 'create-new-tickmark',
      type: ELEMENT_QUICK_ACTIONS.CREATE_NEW_TICKMARK,
      label: 'quick-actions.label.add.annotation.new',
      disabled: false,
      shouldCloseMenuOnClick: true,
      shouldDispatch: false,
    },
    {
      id: 'attach-existing-tickmark',
      type: ELEMENT_QUICK_ACTIONS.ATTACH_EXISTING_TICKMARK,
      label: 'quick-actions.label.add.annotation.existing',
      disabled: false,
      shouldCloseMenuOnClick: false,
      shouldDispatch: false,
    },
  ],
};
export const userFlag = {
  id: 'user-flag',
  type: ELEMENT_QUICK_ACTIONS.USER_FLAG,
  label: 'quick-actions.label.elements.user.flag',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: true,
};
export const removeUserFlag = {
  id: 'remove-user-flag',
  type: ELEMENT_QUICK_ACTIONS.REMOVE_USER_FLAG,
  label: 'quick-actions.label.elements.remove.user.flag',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: true,
};
export const overRideFlag = {
  id: 'override-flag',
  type: ELEMENT_QUICK_ACTIONS.OVERRIDE_FLAG,
  label: 'quick-actions.label.elements.system.flag',
  disabled: false,
  shouldCloseMenuOnClick: false,
  shouldDispatch: false,
};
export const excludeElement = {
  id: 'exclude-element',
  type: ELEMENT_QUICK_ACTIONS.EXCLUDE_ELEMENT,
  label: 'quick-actions.label.elements.exclude.element',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: true,
};
export const removeFormula = {
  id: 'remove-formula',
  type: ELEMENT_QUICK_ACTIONS.REMOVE_FORMULA,
  label: 'quick-actions.label.elements.remove.formula',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: true,
};
export const manageAttributes = {
  id: 'manage-attributes',
  type: ELEMENT_QUICK_ACTIONS.MANAGE_ATTRIBUTES,
  label: 'quick-actions.label.elements.manage.attributes',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: false,
};
export const verify = {
  id: 'verify',
  type: ELEMENT_QUICK_ACTIONS.VERIFY,
  label: 'element-panel.checkbox.verify',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: true,
};
export const unVerify = {
  id: 'unverify',
  type: ELEMENT_QUICK_ACTIONS.UNVERIFY,
  label: 'batch-panel.status.verification.radio.unverifiy',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: true,
};
export const review = {
  id: 'review',
  type: ELEMENT_QUICK_ACTIONS.REVIEW,
  label: 'element-panel.checkbox.review',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: false,
};
export const unReview = {
  id: 'unreview',
  type: ELEMENT_QUICK_ACTIONS.UNREVIEW,
  label: 'batch-panel.status.review.radio.unreview',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: true,
};
export const assignComfort = {
  id: 'assign-comfort',
  type: ELEMENT_QUICK_ACTIONS.ASSIGN_COMFORT,
  label: 'element-panel.checkbox.comfortAssign-option-label',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: true,
};
export const assignComfortLetter = {
  id: 'assign-comfort-letter',
  type: ELEMENT_QUICK_ACTIONS.ASSIGN_COMFORT_LETTER,
  label: 'quick-actions.label.elements.assign.comfort.letter',
  disabled: false,
  shouldCloseMenuOnClick: true,
  children: [
    {
      id: 'create-new-comfort-letter',
      type: ELEMENT_QUICK_ACTIONS.CREATE_NEW_COMFORT_LETTER,
      label: 'quick-actions.label.add.annotation.new',
      disabled: false,
      shouldCloseMenuOnClick: true,
      shouldDispatch: false,
    },
    {
      id: 'attach-existing-comfort-letter',
      type: ELEMENT_QUICK_ACTIONS.ATTACH_EXISTING_COMFORT_LETTER,
      label: 'quick-actions.label.add.annotation.existing',
      disabled: false,
      shouldCloseMenuOnClick: false,
      shouldDispatch: false,
    },
  ],
};
export const changeSign = {
  id: 'change-sign',
  type: ELEMENT_QUICK_ACTIONS.CHANGE_SIGN,
  label: 'element-panel.change.sign-button-title',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: true,
};

export const LOADER = {
  id: 'loading-data',
  type: ELEMENT_QUICK_ACTIONS.LOADER,
  disabled: false,
  shouldCloseMenuOnClick: false,
  shouldDispatch: false,
};
export const addFormula = {
  id: 'add-formula',
  type: ELEMENT_QUICK_ACTIONS.ADDFORMULA,
  label: 'quick-actions.label.elements.add.formula',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: true,
};

export const unlinkAutoTieoutReferences = {
  id: 'unlink-auto-tieout-references',
  type: ELEMENT_QUICK_ACTIONS.UNLINK_AUTO_TIEOUT_REFERENCES,
  label: 'quick-actions.label.elements.unlink.auto.tieout.references',
  disabled: false,
  shouldCloseMenuOnClick: true,
  shouldDispatch: true,
};

export const getQuickActionByElement = (
  elementData,
  isStatementWrappedOrPendingApproval = false,
  mappedElements,
  isCftEnabled,
) => {
  // Early return if elementData is invalid
  if (isNullOrUndefined(elementData) && !elementData?.isLoaded) {
    return [];
  }

  const isVerified = elementData.isVerified();
  const isReviewed = elementData.isReviewed();

  const shouldDisableUnverify = isVerified && isReviewed;
  // Helper to create action with disabled state and deep copy children
  const createAction = (action) => {
    const clonedAction = {
      ...action,
      disabled:
        action.type === ELEMENT_QUICK_ACTIONS.UNVERIFY
          ? shouldDisableUnverify && !isStatementWrappedOrPendingApproval
          : isStatementWrappedOrPendingApproval,
    };

    // Deep clone children if they exist to avoid mutating shared constants
    if (action.children) {
      clonedAction.children = action.children.map((child) => ({
        ...child,
        disabled: isStatementWrappedOrPendingApproval,
      }));
    }

    return clonedAction;
  };

  const isSideBySide = window?.location?.pathname.includes(
    ROUTE_CONSTANTS.SIDE_BY_SIDE,
  );

  // Determine user flag option
  const userFlagOption = createAction(
    elementData?.flagUser ? removeUserFlag : userFlag,
  );

  // Check for system flags and override status
  const hasSystemFlag =
    elementData?.isFormulaFlagged?.() ||
    elementData?.isInternalRefFlagged?.() ||
    elementData?.isWorkpaperFlagged?.();
  const shouldShowOverrideOption =
    hasSystemFlag && !elementData?.isSystemOverrideFlagged?.();

  const showUnlinkOptionsForAutoTieout = !isNullOrUndefined(
    mappedElements?.getSourceElementForTarget?.(elementData?.id),
  );
  /**
   * Quick action menu options in statement /side-by-side view should maintain in this order:
   * - Add Tickmark
   * - Add Workpaper reference (not visible in side-by-side view)
   * - Add Formula             (not visible in side-by-side view)
   * - Exclude element         (not visible in side-by-side view)
   * - Override System Flag    (visible only if element is flagged)
   * - User flag               (if user flagged ? Remove User Flag :User Flag)
   */

  const actions = [createAction(addTickmark)];

  // Add side-by-side conditional actions
  if (!isSideBySide) {
    actions.push(createAction(addWorkpaper), createAction(addFormula));
    // TODO: uncomment and proceed implementation for 7.6 release
    // if (elementData.elementHasFormula) {
    //   actions.push(createAction(removeFormula));
    // }

    actions.push(
      createAction(excludeElement),
      createAction(manageAttributes),
      createAction(isVerified ? unVerify : verify),
      // TODO: uncomment and proceed implementation for 7.6 release
      // createAction(assignComfort),
    );

    // Add review actions based on verification state
    if (isVerified) {
      actions.push(isReviewed ? createAction(unReview) : createAction(review));
    }

    // TODO: uncomment and proceed implementation for 7.6 release
    // if (isCftEnabled) {
    //   actions.push(createAction(assignComfortLetter));
    // }

    actions.push(createAction(changeSign));
  }

  // Add override flag if needed
  if (shouldShowOverrideOption) {
    actions.push(createAction(overRideFlag));
  }

  // Add user flag option
  actions.push(userFlagOption);
  if (showUnlinkOptionsForAutoTieout) {
    actions.push(unlinkAutoTieoutReferences);
  }

  return actions;
};

export const attachTickmarkListColumns = [
  new DataGridCheckboxColumn({
    checkboxId: 'attach-tickmark-col-checkbox-id',
    width: '60px',
  }),
  new DataGridColumn({
    key: 'tickmark-ordinal',
    header: 'quick-actions.attach-existing-tickmark.list.column.tickmarks',
    width: '150px',
    formatter: (statement, { rowKey }) => {
      const colId = `statement-type-col-${rowKey}`;
      return (
        <MultilineEllipsis
          toolTipID={colId}
          text={`{${statement.noteOrdinal}}`}
          isNotInternationalized
        />
      );
    },
  }),
  new DataGridColumn({
    key: 'tickmark-description',
    header: 'quick-actions.attach-existing-tickmark.list.column.description',
    width: '400px',
    formatter: (statement, { rowKey }) => {
      const colId = `statement-type-col-${rowKey}`;
      return (
        <MultilineEllipsis
          toolTipID={colId}
          text={statement.text}
          isNotInternationalized
        />
      );
    },
  }),
];

export const attachWorkpaperListColumns = [
  new DataGridCheckboxColumn({
    checkboxId: 'attach-workpaper-col-checkbox-id',
    width: '60px',
  }),
  new DataGridColumn({
    key: 'workpaper-reference-number',
    header:
      'quick-actions.attach-existing-workpaper.list.column.reference-number',
    width: '150px',
    formatter: (workpaper, { rowKey }) => {
      const colId = `workpaper-ref-number-col-${rowKey}`;
      return (
        <MultilineEllipsis
          toolTipID={colId}
          text={workpaper.referenceNumber}
          isNotInternationalized
        />
      );
    },
  }),
  new DataGridColumn({
    key: 'workpaper-reference-name',
    header:
      'quick-actions.attach-existing-workpaper.list.column.reference-name',
    width: '400px',
    formatter: (workpaper, { rowKey }) => {
      const colId = `workpaper-ref-name-col-${rowKey}`;
      const referenceName = workpaper.referenceName || '';
      return (
        <MultilineEllipsis
          toolTipID={colId}
          text={referenceName}
          isNotInternationalized
        />
      );
    },
  }),
];

export const getContentPanelHeight = ({
  sideBySideViewMode,
  isSourceStatementLoaded,
  tbWorkFlowStatus,
  hasTabGroupHeader,
}) => {
  const isSideBySideView =
    sideBySideViewMode?.viewMode === SIDE_BY_SIDE_COMPARE_MODE;
  const isAutotieoutView =
    sideBySideViewMode?.viewMode === AUTO_TIEOUT_COMPARE_MODE ||
    sideBySideViewMode?.viewMode === TRAIL_BALANCE_MODE;
  const isSideBySideViewLoaded = isSourceStatementLoaded && isSideBySideView;
  const isAutotieoutViewLoaded = isSourceStatementLoaded && isAutotieoutView;
  let height =
    HEADER_PLUGIN_HEIGHT +
    SIDE_BY_SIDE_HEADER_HEIGHT +
    SIDE_BY_SIDE_SUB_HEADER_HEIGHT;

  if ((isSideBySideView || isAutotieoutView) && !isSourceStatementLoaded) {
    return height;
  }
  if (isSideBySideViewLoaded) {
    height = height + SIDE_BY_SIDE_VIEW_FOOTER_HEIGHT;
  }
  if (isAutotieoutViewLoaded) {
    if (sideBySideViewMode?.getAutoTieoutStatusForBanner()) {
      height = height + AUTO_TIEOUT_BANNER_HEIGHT;
    }
    if (hasTabGroupHeader) {
      height = height + AUTO_TIEOUT_TAB_GROUP_HEADER_HEIGHT;
    }
    if (tbWorkFlowStatus?.stale) {
      height = height + AUTO_TIEOUT_STALE_FLAG_BANNER_HEIGHT;
    }
  }
  return height;
};
